import React, { Fragment } from "react";
import TextField from "../../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import InfoIcon from "@mui/icons-material/Info";
import { FormHelperText } from "@mui/material";
import SingleSelect from "../../common/SingleSelect";
import AsyncSelect from "../../common/asyncSelect";
import Checkbox from "../../common/Checkbox";
import Button from "../../common/Button";
import CustomDatePicker from "../../common/CustomDatePicker";
import { checkPrivileges, getTooltipMessage } from "../../../Helpers";
import {
  contractTypes,
  customerTypes,
  creditPeriod,
  c_schemeIdList,
  statuses,
  accStatus,
  defaultStatusesList,
  idIssuerList,
  productTypeList,
  productStatuesList,
  goodsServicesList,
  accountFieldStyle,
} from "./formOptions";
import {
  HtmlTooltip,
  PasswordRequirements,
  WhiteTooltip,
  ValidationIcon,
} from "./FormHelpers";

const EditAccountDetailsSection = (props) => (
  <Fragment>
              {props.editOption &&
                props.function === "updateUser" && (
                  <>
                    <>
                      <h4>{props.translate("accountDetails")}</h4>
                      <Grid
                        container
                        spacing={2}
                        style={{ display: "flex", flexWrap: "wrap" }}
                      >
                        {props.form.userType > 2 && (
                          <Grid
                            item
                            sm={6}
                            md={3}
                            xs={12}
                            style={accountFieldStyle("searchCompany", {
                              zIndex: 99,
                            })}
                          >
                            <SingleSelect
                              array={props.defaultCompaniesList || []}
                              async
                              selectName="companyId"
                              isClearable
                              // loadOptions={props.searchAccountsList.bind()}
                              label={
                                <p style={{ fontSize: "0.9rem" }}>
                                  {props.translate("searchCompany")}
                                </p>
                              }
                              value={
                                props.companySelectedData &&
                                props.companySelectedData.id
                                  ? {
                                      id: props.companySelectedData.id,
                                      value: props.companySelectedData.id,
                                      label:
                                        props.companySelectedData.label,
                                    }
                                  : null
                              }
                              handleChange={props.timezone_handleChange}
                              canAssign={true}
                              menuPlacement="auto"
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  ...(props.addUserFieldErrors?.companyId
                                    ? {
                                        // backgroundColor:
                                        //   "rgba(211, 47, 47, 0.12)",
                                        borderColor: "red",
                                        // boxShadow: state.isFocused
                                        //   ? "0 0 0 1px #d32f2f"
                                        //   : "none",
                                      }
                                    : {}),
                                }),
                              }}
                            />
                          </Grid>
                        )}
                        <Grid
                          item
                          style={accountFieldStyle("contractType")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            id="contractType"
                            select
                            label={props.translate("contractType")}
                            value={props.form.contractType || ""}
                            onChange={props.handleChange("contractType")}
                            SelectProps={{
                              MenuProps: {
                                className: props.classes.menu,
                              },
                            }}
                            margin="dense"
                            fullWidth
                            error={Boolean(
                              props.addUserFieldErrors?.contractType,
                            )}
                            // helperText={props.roleTypes.length ? <span onClick={props.toggleRoles} style={{cursor: 'pointer'}}><b>Select Custom Role</b></span> : ''}
                            required
                          >
                            {contractTypes.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {props.translate(option.name)}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        {props.form.userType === 4 && (
                          <Grid
                            item
                            style={accountFieldStyle("customerType")}
                            md={3}
                            sm={6}
                            xs={12}
                          >
                            <TextField
                              id="customerType"
                              select
                              label={props.translate("customerType")}
                              value={props.form.customerType || ""}
                              onChange={props.handleChange("customerType")}
                              SelectProps={{
                                MenuProps: {
                                  className: props.classes.menu,
                                },
                              }}
                              margin="dense"
                              fullWidth
                              disabled={props.editOption}
                              error={Boolean(
                                props.addUserFieldErrors?.customerType,
                              )}
                              // helperText={props.translate("Enter Value between 0 and 100")}

                              // helperText={props.roleTypes.length ? <span onClick={props.toggleRoles} style={{cursor: 'pointer'}}><b>Select Custom Role</b></span> : ''}
                              required
                            >
                              {customerTypes.map((option) => (
                                <MenuItem key={option.key} value={option.key}>
                                  {props.translate(option.name)}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        )}

                        <Grid
                          item
                          style={accountFieldStyle("accountName")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            // error={props.nameInvalidError}

                            id="name"
                            label={props.translate(
                              "accountTitle (Registeration Name)",
                            )}
                            type="text"
                            placeholder=""
                            value={props.form.accountName}
                            onChange={props.handleChange("accountName")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            required
                            error={Boolean(
                              props.addUserFieldErrors?.accountName,
                            )}
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges("userUpdate")
                                  ? false
                                  : true,
                            }}
                          />
                          {/* <FormHelperText error={props.nameInvalidError ? true : false}>
                                  Special Characters not allowed in  Account Title
                              </FormHelperText> */}
                        </Grid>
                        <Grid
                          item
                          style={accountFieldStyle("nameArabic")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            id="name"
                            label={props.translate("nameArabic")}
                            type="text"
                            placeholder=""
                            value={props.form?.nameArabic || ""}
                            onChange={props.handleChange("nameArabic")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            required={props?.form?.userType === 3}
                            error={Boolean(
                              props.addUserFieldErrors?.nameArabic,
                            )}
                            // required={props.form.userType!==3}
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges("userUpdate")
                                  ? false
                                  : true,
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          style={accountFieldStyle("contractNumber")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            required
                            disabled={props.editOption}
                            id="contractNumber"
                            label={props.translate("contractNumber")}
                            type="text"
                            placeholder=""
                            value={props.form.contractNumber}
                            onChange={props.handleChange("contractNumber")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            error={Boolean(
                              props.addUserFieldErrors?.contractNumber,
                            )}
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges(
                                  "accountCustomerAndContractNumUpdate",
                                )
                                  ? false
                                  : true,
                            }}
                          />
                        </Grid>

                        <Grid
                          item
                          style={accountFieldStyle("accountEmail")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            id="email"
                            error={
                              Boolean(props.accountEmailInvalidError) ||
                              Boolean(
                                props.addUserFieldErrors?.accountEmail,
                              )
                            }
                            label={props.translate("accountEmail")}
                            type="email"
                            placeholder=""
                            value={props.form.accountEmail}
                            onChange={props.handleChange("accountEmail")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            required
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges("userUpdate")
                                  ? false
                                  : true,
                            }}
                          />
                          <FormHelperText
                            error={
                              Boolean(props.accountEmailInvalidError) ||
                              Boolean(
                                props.addUserFieldErrors?.accountEmail,
                              )
                            }
                          >
                            Please enter a valid Account email address.
                          </FormHelperText>
                          {/* <Healing */}
                        </Grid>
                        <Grid
                          item
                          style={accountFieldStyle("description")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            id="description"
                            label={props.translate("sharedDescription")}
                            type="text"
                            placeholder=""
                            value={props.form.accountDescription || ""}
                            onChange={props.handleChange(
                              "accountDescription",
                            )}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges("userUpdate")
                                  ? false
                                  : true,
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          style={accountFieldStyle("contactPerson")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            id="contact"
                            label={props.translate("contactPerson")}
                            type="text"
                            placeholder=""
                            value={props.form.accountContact}
                            onChange={props.handleChange("accountContact")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges("userUpdate")
                                  ? false
                                  : true,
                            }}
                          />
                        </Grid>
                        {props.form.userType &&
                          props.form.userType !== 4 && (
                            <Grid
                              item
                              style={accountFieldStyle("customerNumber")}
                              md={3}
                              sm={6}
                              xs={12}
                            >
                              <TextField
                                id="customerNumber"
                                label={props.translate("customerNumber")}
                                type="text"
                                placeholder=""
                                value={props.form?.customerNumber || ""}
                                onChange={props.handleChange(
                                  "customerNumber",
                                )}
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                InputProps={{
                                  readOnly:
                                    !props.updateOption ||
                                    checkPrivileges(
                                      "accountCustomerAndContractNumUpdate",
                                    )
                                      ? false
                                      : true,
                                }}
                              />
                            </Grid>
                          )}
                        {props.form.userType &&
                          props.form.userType !== 4 && (
                            <>
                              <Grid
                                item
                                style={accountFieldStyle("accType")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="status"
                                  select
                                  label={props.translate("accType")}
                                  value={props.form.status || ""}
                                  onChange={props.handleChange("status")}
                                  SelectProps={{
                                    MenuProps: {
                                      className: props.classes.menu,
                                    },
                                  }}
                                  margin="dense"
                                  fullWidth
                                  required={[3, 4, 5, 6].includes(
                                    props.form.userType,
                                  )}
                                  error={Boolean(
                                    props.addUserFieldErrors?.status,
                                  )}
                                >
                                  {statuses.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {props.translate(option.name)}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Grid>
                              {((props.form.contractType === 1 &&
                                props?.form?.status === "advance") ||
                                props.form.contractType === 3 ||
                                props.form.contractType === 2) && (
                                <Grid
                                  item
                                  style={accountFieldStyle(
                                    "agreedAdvancePayment",
                                  )}
                                  md={3}
                                  sm={6}
                                  xs={12}
                                >
                                  <TextField
                                    // required
                                    id="c_agreedAdvancePayment"
                                    label={props.translate(
                                      "c_agreedAdvancePayment",
                                    )}
                                    placeholder=""
                                    value={
                                      props?.accountsform
                                        ?.c_agreedAdvancePayment ?? ""
                                    }
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (
                                        val === "" ||
                                        (!isNaN(val) && Number(val) >= 0)
                                      ) {
                                        props.handleChangeAttributes(
                                          "c_agreedAdvancePayment",
                                        )(e);
                                      }
                                    }}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    type="number"
                                  />
                                </Grid>
                              )}
                              {props?.form?.status !== "advance" &&
                                ((props.form.contractType === 1 &&
                                  props?.form?.status === "credit") ||
                                  props.form.contractType === 3 ||
                                  props.form.contractType === 2) && (
                                  <Grid
                                    item
                                    style={accountFieldStyle("creditLimit")}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                  >
                                    <TextField
                                      id="creditLimit"
                                      label={props.translate(
                                        "creditLimit",
                                      )}
                                      type="number"
                                      placeholder=""
                                      value={props.form?.creditLimit || ""}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === "" || Number(val) >= 0) {
                                          props.handleChange(
                                            "creditLimit",
                                          )(e);
                                        }
                                      }}
                                      variant="outlined"
                                      margin="dense"
                                      fullWidth
                                      disabled={
                                        props.editOption &&
                                        !checkPrivileges(
                                          "accountFinancialFieldEdit",
                                        )
                                      }
                                      InputProps={{
                                        readOnly:
                                          !props.updateOption ||
                                          checkPrivileges(
                                            "accountCustomerAndContractNumUpdate",
                                          )
                                            ? false
                                            : true,
                                      }}
                                    />
                                  </Grid>
                                )}
                              <Grid
                                item
                                style={accountFieldStyle("taxNumber")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  required={
                                    props?.form?.userType === 5 ||
                                    props?.form?.userType === 6
                                    // props?.form?.userType === 3
                                  }
                                  id="c_taxNumber"
                                  label={props.translate("taxNumber")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_taxNumber || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_taxNumber",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  error={Boolean(
                                    props.addUserFieldErrors?.c_taxNumber,
                                  )}
                                  disabled={
                                    props.editOption &&
                                    !checkPrivileges(
                                      "accountFinancialFieldEdit",
                                    )
                                  }
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              {props.form.userType === 3 ? (
                                <Grid
                                  item
                                  md={3}
                                  sm={6}
                                  xs={12}
                                  style={accountFieldStyle("schemeId", {
                                    position: "relative",
                                  })}
                                >
                                  {/* <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ width: "96%"}}> */}
                                  <TextField
                                    id="c_schemeId"
                                    select
                                    label={props.translate("schemeID")}
                                    value={props?.accountsform?.c_schemeId}
                                    onChange={props.handleChangeAttributes(
                                      "c_schemeId",
                                    )}
                                    handleChangeAttributes={props.handleChangeAttributes(
                                      "c_schemeId",
                                    )}
                                    SelectProps={{
                                      MenuProps: {
                                        className: props.classes.menu,
                                      },
                                    }}
                                    margin="dense"
                                    fullWidth
                                    required
                                  >
                                    {c_schemeIdList.map((option) => (
                                      <MenuItem
                                        key={option.key}
                                        value={option.name}
                                      >
                                        {props.translate(option.name)}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                  {/* </div><HtmlTooltip
                              title={
                                <span style={{fontSize:"18px", fontWeight: "bold", width:"200px", height:"150px", padding:"5px 0px" }}> 
                                  { {props.translate(getTooltipMessage(props?.accountsform?.c_schemeId,"c_schemeId"))}

                                </span>
                              }
                              style={{ color: "green" }} // Changed the color to green
                            >
                              <InfoIcon fontSize="large"  style={{ fontSize: 24, color: "grey" , marginLeft:"5px" }} />  
                            </HtmlTooltip></div> */}
                                </Grid>
                              ) : null}
                              {props.form.userType === 3 &&
                              props.accountsform?.c_schemeId ? (
                                <Grid
                                  item
                                  style={accountFieldStyle("schemeNumber")}
                                  md={3}
                                  sm={6}
                                  xs={12}
                                >
                                  <TextField
                                    // required
                                    id={`c_schemeNumber`}
                                    label={props.translate(`schemeNumber`)}
                                    type="text"
                                    placeholder=""
                                    value={
                                      props.accountsform?.c_schemeNumber
                                        ? props.newField || ""
                                        : ""
                                    }
                                    onChange={props.handleChangeAttributes(
                                      `number`,
                                    )}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                  />

                                  {/* <TextField
                            // required
                            id="c_crNumber"
                            label={props.translate("crNumber")}
                            type="text"
                            placeholder=""
                            value={props?.accountsform?.c_crNumber || ""}
                            onChange={props.handleChangeAttributes(
                              "c_crNumber"
                            )}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                          /> */}
                                </Grid>
                              ) : null}
                              {props.form.userType === 3 && (
                                <>
                                  <Grid
                                    item
                                    style={accountFieldStyle("markup")}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                  >
                                    <TextField
                                      required
                                      id="markup"
                                      label={props.translate("markup")}
                                      type="number"
                                      placeholder=""
                                      value={
                                        props.form.markup !== undefined
                                          ? props.form.markup
                                          : ""
                                      }
                                      onChange={props.handleChange(
                                        "markup",
                                      )}
                                      variant="outlined"
                                      margin="dense"
                                      fullWidth
                                      error={
                                        Boolean(
                                          props.addUserFieldErrors?.markup,
                                        ) || Boolean(props.markupError)
                                      }
                                      helperText={
                                        props && props.markupError
                                          ? props.markupError
                                          : ""
                                      }
                                      disabled={
                                        props.editOption &&
                                        !checkPrivileges(
                                          "accountFinancialFieldEdit",
                                        )
                                      }
                                      InputProps={{
                                        readOnly:
                                          !props.updateOption ||
                                          checkPrivileges(
                                            "accountCustomerAndContractNumUpdate",
                                          )
                                            ? false
                                            : true,
                                      }}
                                    />
                                  </Grid>
                                </>
                              )}
                              {(props.form.userType === 1 ||
                                props.form.userType === 2 ||
                                props.form.userType === 3) && (
                                <>
                                  <Grid
                                    item
                                    style={accountFieldStyle("vatPercentage")}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                  >
                                    <TextField
                                      required
                                      id="vatPercentage"
                                      label={props.translate(
                                        "vatPercentage",
                                      )}
                                      type="number"
                                      placeholder=""
                                      value={
                                        props.form.vatPercentage !==
                                        undefined
                                          ? props.form.vatPercentage
                                          : ""
                                      }
                                      onChange={props.handleChange(
                                        "vatPercentage",
                                      )}
                                      variant="outlined"
                                      margin="dense"
                                      fullWidth
                                      error={
                                        Boolean(
                                          props.addUserFieldErrors
                                            ?.vatPercentage,
                                        ) ||
                                        Boolean(props.vatPercentageError)
                                      }
                                      helperText={
                                        props &&
                                        props.vatPercentageError
                                          ? props.vatPercentageError
                                          : ""
                                      }
                                      disabled={
                                        props.editOption &&
                                        !checkPrivileges(
                                          "accountFinancialFieldEdit",
                                        )
                                      }
                                      InputProps={{
                                        readOnly:
                                          !props.updateOption ||
                                          checkPrivileges(
                                            "accountCustomerAndContractNumUpdate",
                                          )
                                            ? false
                                            : true,
                                      }}
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    style={accountFieldStyle("pacContractId")}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                  >
                                    <TextField
                                      id="pacContractId"
                                      label={props.translate(
                                        "pacContractId",
                                      )}
                                      type="text"
                                      // required
                                      placeholder=""
                                      value={
                                        props.form?.pacContractId || ""
                                      }
                                      onChange={props.handleChange(
                                        "pacContractId",
                                      )}
                                      variant="outlined"
                                      margin="dense"
                                      fullWidth
                                    />
                                  </Grid>
                                </>
                              )}
                              <Grid
                                item
                                style={accountFieldStyle("address")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_address"
                                  label={props.translate("address")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_address || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_address",
                                  )}
                                  // required={props?.form?.userType === 3}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("addressArabic")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_addressArabic"
                                  label={props.translate("addressArabic")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_addressArabic ||
                                    ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_addressArabic",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  required={props.form.userType === 3}
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("district")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_district"
                                  label={props.translate(
                                    "district (City Subdivision)",
                                  )}
                                  type="text"
                                  placeholder=""
                                  required={
                                    props?.form?.userType === 5 ||
                                    props?.form?.userType === 6 ||
                                    props.form.userType === 3
                                  }
                                  value={
                                    props?.accountsform?.c_district || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_district",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("districtArabic")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_districtArabic"
                                  label={props.translate("districtArabic")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform
                                      ?.c_districtArabic || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_districtArabic",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  required={props.form.userType === 3}
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("city")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                {/* <SingleSelect
                                  array={props?.cities || []}
                                  async
                                  isClearable
                                  selectName="city"
                                  label={props.translate("city")}
                                  value={
                                    props.citySelectedData &&
                                      props.citySelectedData
                                      ? {
                                        id:
                                          props.citySelectedData.id ||
                                          props.citySelectedData,
                                        value:
                                          props.citySelectedData.id ||
                                          props.citySelectedData,
                                        label:
                                          props.citySelectedData.name ||
                                          props.citySelectedData.cityId,
                                      }
                                      : ""
                                  }
                                  handleChange={props.timezone_handleChange}
                                  canRemove={true}
                                  canAssign={true}
                                /> */}
                                <TextField
                                  id="c_city"
                                  label={props.translate("city")}
                                  type="text"
                                  placeholder=""
                                  value={props?.accountsform?.c_city || ""}
                                  onChange={props.handleChangeAttributes(
                                    "c_city",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  // required={
                                  //   props?.form?.userType === 5 ||
                                  //   props?.form?.userType === 6 ||
                                  //   props?.form?.userType === 3
                                  // }
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("cityArabic")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_cityArabic"
                                  label={props.translate("cityArabic")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_cityArabic || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_cityArabic",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  // required={props?.form?.userType === 3}
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("country")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_country"
                                  label={props.translate("country")}
                                  type="text"
                                  required={
                                    props?.form?.userType === 5 ||
                                    props?.form?.userType === 6
                                  }
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_country || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_country",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("countryArabic")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_countryArabic"
                                  label={props.translate("countryArabic")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_countryArabic ||
                                    ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_countryArabic",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("postalCode")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_postalCode"
                                  label={props.translate("postalCode")}
                                  type="text"
                                  placeholder=""
                                  // required={
                                  //   props?.form?.userType === 3 ||
                                  //   props?.form?.userType === 5 ||
                                  //   props?.form?.userType === 6
                                  // }
                                  value={
                                    props?.accountsform?.c_postalCode || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_postalCode",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  error={Boolean(
                                    props.addUserFieldErrors?.c_postalCode,
                                  )}
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>

                              <Grid
                                item
                                style={accountFieldStyle("category")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="accStatus"
                                  select
                                  label={props.translate("category")}
                                  value={
                                    props?.accountsform?.accStatus || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "accStatus",
                                  )}
                                  SelectProps={{
                                    MenuProps: {
                                      className: props.classes.menu,
                                    },
                                  }}
                                  margin="dense"
                                  fullWidth
                                  // helperText={props.roleTypes.length ? <span onClick={props.toggleRoles} style={{cursor: 'pointer'}}><b>Select Custom Role</b></span> : ''}
                                >
                                  {accStatus.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {props.translate(option.name)}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Grid>
                              {(props.form.userType === 1 ||
                                props.form.userType === 2 ||
                                props.form.userType === 3) && (
                                <Grid
                                  item
                                  style={accountFieldStyle(
                                    "monthlyRevenueTarget",
                                  )}
                                  md={3}
                                  sm={6}
                                  xs={12}
                                >
                                  <TextField
                                    id="monthlyRevenueTarget"
                                    label={props.translate(
                                      "monthlyRevenueTarget",
                                    )}
                                    type="number"
                                    placeholder=""
                                    value={
                                      props.form?.monthlyRevenueTarget ||
                                      ""
                                    }
                                    onChange={props.handleChange(
                                      "monthlyRevenueTarget",
                                    )}
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    // InputProps={{
                                    //   readOnly:
                                    //     !props.updateOption || checkPrivileges('accountCustomerAndContractNumUpdate')
                                    //       ? false
                                    //       : true
                                    // }}
                                  />
                                </Grid>
                              )}
                              <Grid
                                item
                                style={accountFieldStyle("yearlyRevenueTarget")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="yearlyRevenueTarget"
                                  label={props.translate(
                                    "yearlyRevenueTarget",
                                  )}
                                  type="number"
                                  placeholder=""
                                  value={
                                    props.form?.yearlyRevenueTarget || ""
                                  }
                                  onChange={props.handleChange(
                                    "yearlyRevenueTarget",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              {props.form.userType &&
                                props?.form?.status !== "advance" &&
                                props.form.userType !== 4 && (
                                  <Grid
                                    item
                                    style={accountFieldStyle("creditPeriod")}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                  >
                                    <TextField
                                      id="creditPeriod"
                                      select
                                      label={props.translate(
                                        "creditPeriod",
                                      )}
                                      value={props.form.creditPeriod || 0}
                                      onChange={props.handleChange(
                                        "creditPeriod",
                                      )}
                                      SelectProps={{
                                        MenuProps: {
                                          className: props.classes.menu,
                                        },
                                      }}
                                      margin="dense"
                                      fullWidth
                                      error={Boolean(
                                        props.addUserFieldErrors
                                          ?.creditPeriod,
                                      )}
                                      disabled={
                                        props.editOption &&
                                        !checkPrivileges(
                                          "accountFinancialFieldEdit",
                                        )
                                      }
                                      // helperText={props.roleTypes.length ? <span onClick={props.toggleRoles} style={{cursor: 'pointer'}}><b>Select Custom Role</b></span> : ''}
                                      required={
                                        props?.form?.userType === 5 ||
                                        props?.form?.userType === 6
                                      }
                                    >
                                      {creditPeriod.map((option) => (
                                        <MenuItem
                                          key={option.key}
                                          value={option.name}
                                        >
                                          {props.translate(option.name)}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </Grid>
                                )}
                              {/* { console.log(" 1 c_schemeId =====", props?.accountsform?.c_schemeId)} */}

                              <Grid
                                item
                                style={accountFieldStyle("installmentPayment")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  // required
                                  id="c_installmentPayment"
                                  label={props.translate(
                                    "installmentPayment",
                                  )}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform
                                      ?.c_installmentPayment || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_installmentPayment",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  // InputProps={{
                                  //   readOnly:
                                  //     !props.updateOption ||
                                  //     checkPrivileges("userUpdate")
                                  //       ? false
                                  //       : true,
                                  // }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("repaymentPeriod")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  // required
                                  id="c_repaymentPeriod"
                                  label={props.translate(
                                    "repaymentPeriod",
                                  )}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform
                                      ?.c_repaymentPeriod || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_repaymentPeriod",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  // InputProps={{
                                  //   readOnly:
                                  //     !props.updateOption ||
                                  //     checkPrivileges("userUpdate")
                                  //       ? false
                                  //       : true,
                                  // }}
                                />
                              </Grid>

                              <Grid
                                item
                                md={3}
                                sm={6}
                                xs={12}
                                style={accountFieldStyle("idIssuer", {
                                  position: "relative",
                                })}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ width: "96%" }}>
                                    <TextField
                                      id="c_idIssuer"
                                      select
                                      label={props.translate("idIssuer")}
                                      value={
                                        props?.accountsform?.c_idIssuer
                                      }
                                      onChange={props.handleChangeAttributes(
                                        "c_idIssuer",
                                      )}
                                      SelectProps={{
                                        MenuProps: {
                                          className: props.classes.menu,
                                        },
                                      }}
                                      margin="dense"
                                      fullWidth
                                      required
                                      disabled={
                                        props.editOption &&
                                        !checkPrivileges(
                                          "accountFinancialFieldEdit",
                                        )
                                      }
                                    >
                                      {idIssuerList.map((option) => (
                                        <MenuItem
                                          key={option.key}
                                          value={option.name}
                                        >
                                          {props.translate(option.name)}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </div>
                                  <HtmlTooltip
                                    title={
                                      <span
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "bold",
                                          width: "200px",
                                          height: "150px",
                                          padding: "5px 0px",
                                        }}
                                      >
                                        {/* {props.translate("111111111")}  */}
                                        {getTooltipMessage(
                                          props?.accountsform?.c_idIssuer,
                                          "c_idIssuer",
                                        )}
                                      </span>
                                    }
                                    style={{ color: "green" }} // Changed the color to green
                                  >
                                    <InfoIcon
                                      fontSize="large"
                                      style={{
                                        fontSize: 24,
                                        color: "grey",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  </HtmlTooltip>
                                </div>
                              </Grid>
                              <Grid
                                item
                                md={3}
                                sm={6}
                                xs={12}
                                style={accountFieldStyle("productType", {
                                  position: "relative",
                                })}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ width: "96%" }}>
                                    <TextField
                                      id="c_productType"
                                      select
                                      label={props.translate(
                                        "productType",
                                      )}
                                      value={
                                        props?.accountsform?.c_productType
                                      }
                                      onChange={props.handleChangeAttributes(
                                        "c_productType",
                                      )}
                                      SelectProps={{
                                        MenuProps: {
                                          className: props.classes.menu,
                                        },
                                      }}
                                      margin="dense"
                                      fullWidth
                                      required={
                                        props?.form?.userType !== 3
                                      }
                                    >
                                      {productTypeList.map((option) => (
                                        <MenuItem
                                          key={option.key}
                                          value={option.name}
                                        >
                                          {props.translate(option.name)}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </div>
                                  <HtmlTooltip
                                    title={
                                      <span
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "bold",
                                          width: "200px",
                                          height: "150px",
                                          padding: "5px 0px",
                                        }}
                                      >
                                        {/* {props.translate("111111111")}  */}
                                        {getTooltipMessage(
                                          props?.accountsform
                                            ?.c_productType,
                                          "c_productType",
                                        )}
                                      </span>
                                    }
                                    style={{ color: "green" }} // Changed the color to green
                                  >
                                    <InfoIcon
                                      fontSize="large"
                                      style={{
                                        fontSize: 24,
                                        color: "grey",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  </HtmlTooltip>
                                </div>
                              </Grid>
                              <Grid
                                item
                                md={3}
                                sm={6}
                                xs={12}
                                style={accountFieldStyle("productStatus", {
                                  position: "relative",
                                })}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ width: "96%" }}>
                                    <TextField
                                      id="c_productStatus"
                                      select
                                      label={props.translate(
                                        "productStatus",
                                      )}
                                      value={
                                        props?.accountsform
                                          ?.c_productStatus
                                      }
                                      onChange={props.handleChangeAttributes(
                                        "c_productStatus",
                                      )}
                                      SelectProps={{
                                        MenuProps: {
                                          className: props.classes.menu,
                                        },
                                      }}
                                      margin="dense"
                                      fullWidth
                                      required={
                                        props?.form?.userType !== 3
                                      }
                                    >
                                      {productStatuesList.map((option) => (
                                        <MenuItem
                                          key={option.key}
                                          value={option.name}
                                        >
                                          {props.translate(option.name)}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </div>
                                  <HtmlTooltip
                                    title={
                                      <span
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "bold",
                                          width: "200px",
                                          height: "150px",
                                          padding: "5px 0px",
                                        }}
                                      >
                                        {/* {props.translate("111111111")}  */}
                                        {getTooltipMessage(
                                          props?.accountsform
                                            ?.c_productStatus,
                                          "c_productStatus",
                                        )}
                                      </span>
                                    }
                                    style={{ color: "green" }} // Changed the color to green
                                  >
                                    <InfoIcon
                                      fontSize="large"
                                      style={{
                                        fontSize: 24,
                                        color: "grey",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  </HtmlTooltip>
                                </div>
                              </Grid>
                              <Grid
                                item
                                md={3}
                                sm={6}
                                xs={12}
                                style={accountFieldStyle("defaultStatus", {
                                  position: "relative",
                                })}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ width: "96%" }}>
                                    <TextField
                                      id="c_defaultStatus"
                                      select
                                      label={props.translate(
                                        "defaultStatus",
                                      )}
                                      value={
                                        props?.accountsform
                                          ?.c_defaultStatus
                                      }
                                      onChange={props.handleChangeAttributes(
                                        "c_defaultStatus",
                                      )}
                                      SelectProps={{
                                        MenuProps: {
                                          className: props.classes.menu,
                                        },
                                      }}
                                      margin="dense"
                                      fullWidth
                                      required={
                                        props?.form?.userType !== 3
                                      }
                                    >
                                      {defaultStatusesList.map((option) => (
                                        <MenuItem
                                          key={option.key}
                                          value={option.name}
                                        >
                                          {props.translate(option.name)}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </div>
                                  <HtmlTooltip
                                    title={
                                      <span
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "bold",
                                          width: "200px",
                                          height: "150px",
                                          padding: "5px 0px",
                                        }}
                                      >
                                        {/* {props.translate("111111111")}  */}
                                        {getTooltipMessage(
                                          props?.accountsform
                                            ?.c_defaultStatus,
                                          "c_defaultStatus",
                                        )}
                                      </span>
                                    }
                                    style={{ color: "green" }} // Changed the color to green
                                  >
                                    <InfoIcon
                                      fontSize="large"
                                      style={{
                                        fontSize: 24,
                                        color: "grey",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  </HtmlTooltip>
                                </div>
                              </Grid>
                              <Grid
                                item
                                md={3}
                                sm={6}
                                xs={12}
                                style={accountFieldStyle("goodsServices", {
                                  position: "relative",
                                })}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ width: "96%" }}>
                                    <TextField
                                      id="c_goodsServices"
                                      select
                                      label={props.translate(
                                        "goodsServices",
                                      )}
                                      value={
                                        props?.accountsform
                                          ?.c_goodsServices
                                      }
                                      onChange={props.handleChangeAttributes(
                                        "c_goodsServices",
                                      )}
                                      SelectProps={{
                                        MenuProps: {
                                          className: props.classes.menu,
                                        },
                                      }}
                                      margin="dense"
                                      fullWidth
                                      required={
                                        props?.form?.userType !== 3
                                      }
                                    >
                                      {goodsServicesList.map((option) => (
                                        <MenuItem
                                          key={option.key}
                                          value={option.name}
                                        >
                                          {props.translate(option.name)}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </div>
                                  <HtmlTooltip
                                    title={
                                      <span
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "bold",
                                          width: "200px",
                                          height: "150px",
                                          padding: "5px 0px",
                                        }}
                                      >
                                        {getTooltipMessage(
                                          props?.accountsform
                                            ?.c_goodsServices,
                                          "c_goodsServices",
                                        )}
                                      </span>
                                    }
                                    style={{ color: "green" }} // Changed the color to green
                                  >
                                    <InfoIcon
                                      fontSize="large"
                                      style={{
                                        fontSize: 24,
                                        color: "grey",
                                        marginLeft: "5px",
                                      }}
                                    />
                                  </HtmlTooltip>
                                </div>
                              </Grid>

                              <Grid
                                item
                                style={accountFieldStyle("buildingNo")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_buildingNo"
                                  label={props.translate("buildingNo")}
                                  type="text"
                                  placeholder=""
                                  // required={
                                  //   props?.form?.userType === 5 ||
                                  //   props?.form?.userType === 6
                                  // }
                                  value={
                                    props?.accountsform?.c_buildingNo || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_buildingNo",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              {/* <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                  id="c_buildingNoArabic"
                                  label={props.translate(
                                    "buildingNoArabic"
                                  )}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform
                                      ?.c_buildingNoArabic || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_buildingNoArabic"
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid> */}
                              <Grid
                                item
                                style={accountFieldStyle("streetName")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_streetName"
                                  label={props.translate("streetName")}
                                  type="text"
                                  placeholder=""
                                  // required={
                                  //   props?.form?.userType === 5 ||
                                  //   props?.form?.userType === 6 ||
                                  //   props?.form?.userType === 3
                                  // }
                                  value={
                                    props?.accountsform?.c_streetName || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_streetName",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("streetNameArabic")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_streetNameArabic"
                                  label={props.translate(
                                    "streetNameArabic",
                                  )}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform
                                      ?.c_streetNameArabic || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_streetNameArabic",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  required={props.form.userType === 3}
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>

                              <Grid
                                item
                                style={accountFieldStyle("additionalNo")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_additionalNo"
                                  label={props.translate("additionalNo")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_additionalNo ||
                                    ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_additionalNo",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("otherSellerID")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_otherSellerID"
                                  label={props.translate("otherSellerID")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_otherSellerID ||
                                    ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_otherSellerID",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              {/* <Grid item md={3} sm={6} xs={12}>
                          <TextField
                            id="c_VATNumber"
                            label={props.translate("VATNumber")}
                            type="text"
                            placeholder=""
                            value={props?.accountsform?.c_VATNumber || ""}
                            onChange={props.handleChangeAttributes(
                              "c_VATNumber"
                            )}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges("userUpdate")
                                  ? false
                                  : true,
                            }}
                          />
                        </Grid> */}
                              <Grid
                                item
                                style={accountFieldStyle("region")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <TextField
                                  id="c_Location"
                                  label={props.translate("Region")}
                                  type="text"
                                  placeholder=""
                                  value={
                                    props?.accountsform?.c_Location || ""
                                  }
                                  onChange={props.handleChangeAttributes(
                                    "c_Location",
                                  )}
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputProps={{
                                    readOnly:
                                      !props.updateOption ||
                                      checkPrivileges("userUpdate")
                                        ? false
                                        : true,
                                  }}
                                />
                              </Grid>
                              {props.form.userType === 3 && (
                                <Grid
                                  item
                                  sm={6}
                                  md={3}
                                  xs={12}
                                  style={accountFieldStyle(
                                    "searchAccountManager",
                                    { zIndex: 99 },
                                  )}
                                >
                                  <SingleSelect
                                    key={`c_am-${(props.defaultAccountManagerList || []).length}`}
                                    array={
                                      props.defaultAccountManagerList || []
                                    }
                                    async
                                    loadOptions={props.searchAccountManagersList}
                                    selectName="amUserId"
                                    isClearable
                                    cacheOptions={false}
                                    label={
                                      <p style={{ fontSize: "0.9rem" }}>
                                        {props.translate(
                                          "searchAccountManager",
                                        )}
                                        <span style={{ color: "red" }}> *</span>
                                      </p>
                                    }
                                    value={
                                      props.managerAccountSelect &&
                                      props.managerAccountSelect.id
                                        ? {
                                            id: props.managerAccountSelect
                                              .id,
                                            value:
                                              props.managerAccountSelect
                                                .id,
                                            label:
                                              props.managerAccountSelect
                                                .name,
                                          }
                                        : null
                                    }
                                    handleChange={
                                      props.timezone_handleChange
                                    }
                                    canAssign={true}
                                    menuPlacement="auto"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        ...(props.addUserFieldErrors?.amUserId
                                          ? { borderColor: "red" }
                                          : {}),
                                      }),
                                    }}
                                  />
                                </Grid>
                              )}
                              {/* <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          id="c_contractComponents"
                          label={props.translate("contractComponents")}
                          type="text"
                          placeholder=""
                          value={
                            props?.accountsform?.c_contractComponents || ""
                          }
                          onChange={props.handleChangeAttributes(
                            "c_contractComponents"
                          )}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          InputProps={{
                            readOnly:
                              !props.updateOption ||
                              checkPrivileges("userUpdate")
                                ? false
                                : true,
                          }}
                        />
                      </Grid> */}
                              {/* <Grid item md={3} sm={6} xs={12}>
                  <TextField
                    id='termsConditions'
                    label={props.translate('termsConditions')}
                    type='text'
                    placeholder=''
                    value={props.form?.termsConditions || ''}
                    onChange={props.handleChange('termsConditions')}
                    variant='outlined'
                    margin='dense'
                    fullWidth
                    InputProps={{
                      readOnly:
                        !props.updateOption || checkPrivileges('accountCustomerAndContractNumUpdate')
                          ? false
                          : true
                    }}
                  />
                </Grid> */}
                              {/* <Grid item md={3} sm={6} xs={12}>
                        <TextField
                          id="c_pricing"
                          label={props.translate("pricing")}
                          type="text"
                          placeholder=""
                          value={props.accountsform?.c_pricing || ""}
                          onChange={props.handleChangeAttributes("c_pricing")}
                          variant="outlined"
                          margin="dense"
                          fullWidth
                          InputProps={{
                            readOnly:
                              !props.updateOption ||
                              checkPrivileges(
                                "accountCustomerAndContractNumUpdate"
                              )
                                ? false
                                : true,
                          }}
                        />
                      </Grid> */}
                            </>
                          )}
                        <Grid
                          item
                          style={accountFieldStyle("contractName")}
                          md={3}
                          sm={6}
                          xs={12}
                        >
                          <TextField
                            id="contractName"
                            // error={props.nameInvalidError}
                            label={props.translate("contractName")}
                            type="text"
                            placeholder=""
                            required
                            error={Boolean(
                              props.addUserFieldErrors?.contractName,
                            )}
                            value={props.form?.contractName || ""}
                            onChange={props.handleChange("contractName")}
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            InputProps={{
                              readOnly:
                                !props.updateOption ||
                                checkPrivileges("userUpdate")
                                  ? false
                                  : true,
                            }}
                          />
                          {/* <FormHelperText error={props.nameInvalidError ? true : false}>
                                  Special Characters not allowed in Contract Name
                              </FormHelperText> */}
                        </Grid>

                        {props.form.userType === 4 &&
                          props.form.customerType === 1 && (
                            <Grid
                              item
                              md={3}
                              sm={6}
                              xs={12}
                              style={{ zIndex: 99 }}
                            >
                              <AsyncSelect
                                value={
                                  props.form.garage &&
                                  props.form.garage.id
                                    ? {
                                        id: props.form.garage.id,
                                        value: props.form.garage.id,
                                        label: props.form.garage.name,
                                        uniqueId:
                                          props.form.garage.uniqueId,
                                      }
                                    : props.form.garageNumber
                                      ? {
                                          label: props.form.garageNumber,
                                        }
                                      : ""
                                }
                                placeholder={props.translate("garage")}
                                selectName="garage"
                                defaultOptions={props.defaultGarageOptions}
                                handleChange={props.handleChangeExpense}
                                loadOptions={props.searchGarageList}
                                isMulti={false}
                              />
                            </Grid>
                          )}

                        {props.form.userType &&
                          props.form.userType !== 4 && (
                            <>
                              <Grid
                                item
                                style={accountFieldStyle("contractStartDate")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <CustomDatePicker
                                  format="DD/MM/YYYY"
                                  error={false}
                                  label={props.translate(
                                    "contractStartDate",
                                  )}
                                  fullWidth={true}
                                  value={
                                    props.form &&
                                    props.form.contractStartDate
                                      ? `${props.form.contractStartDate}`
                                      : null
                                  }
                                  onChange={props.handleChange(
                                    "contractStartDate",
                                  )}
                                  disabled={
                                    props.editOption &&
                                    !checkPrivileges(
                                      "accountFinancialFieldEdit",
                                    )
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle("contractEndDate")}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <CustomDatePicker
                                  format="DD/MM/YYYY"
                                  // error={false}
                                  label={props.translate(
                                    "contractEndDate",
                                  )}
                                  fullWidth={true}
                                  value={
                                    props &&
                                    props.form &&
                                    props.form.contractEndDate
                                      ? new Date(
                                          `${props.form.contractEndDate}`,
                                        )
                                      : null
                                  }
                                  onChange={props.handleChange(
                                    "contractEndDate",
                                  )}
                                  disabled={
                                    props.editOption &&
                                    !checkPrivileges(
                                      "accountFinancialFieldEdit",
                                    )
                                  }
                                  error={
                                    Boolean(
                                      props.addUserFieldErrors
                                        ?.contractEndDate,
                                    ) ||
                                    Boolean(props.contractEndDateError)
                                  }
                                />
                              </Grid>
                              <Grid
                                item
                                style={accountFieldStyle(
                                  "defaultSatisfactionDate",
                                )}
                                md={3}
                                sm={6}
                                xs={12}
                              >
                                <CustomDatePicker
                                  format="DD/MM/YYYY"
                                  // error={false}
                                  label={props.translate(
                                    "defaultSatisfactionDate",
                                  )}
                                  fullWidth
                                  value={
                                    props &&
                                    props.form &&
                                    props.form.defaultSatisfactionDate
                                      ? new Date(
                                          `${props.form.defaultSatisfactionDate}`,
                                        )
                                      : null
                                  }
                                  onChange={props.handleChange(
                                    "defaultSatisfactionDate",
                                  )}
                                />
                              </Grid>
                              <Grid
                                item
                                md={3}
                                sm={6}
                                xs={12}
                                style={accountFieldStyle("settleDate")}
                              >
                                <CustomDatePicker
                                  format="DD/MM/YYYY"
                                  // error={false}
                                  label={props.translate("settleDate")}
                                  fullWidth
                                  value={
                                    props &&
                                    props.form &&
                                    props.form.settleDate
                                      ? new Date(
                                          `${props.form.settleDate}`,
                                        )
                                      : null
                                  }
                                  onChange={props.handleChange(
                                    "settleDate",
                                  )}
                                />
                              </Grid>
                            </>
                          )}
                        {props.form.userType === 3 && (
                          <Grid item xl={3} sm={6} md={4} xs={12}>
                            <Checkbox
                              checked={
                                props.accountsform.accountControl || false
                              }
                              onChange={props.handleChangeAttributes(
                                "accountControl",
                              )}
                              canAssign
                              canRemove
                              label={props.translate("accountControl")}
                            />
                          </Grid>
                        )}
                        <Grid
                          item
                          md={6}
                          sm={6}
                          xs={12}
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          {/* <Tooltip title='Upload Image'>
                            <Button
                              style={{ width: 'fit-content', marginTop: '8px' }}
                              variant='contained'
                              margin='dense'
                              component="label"
                              onClick={(e)=> console.log(e)}
                              > */}
                          <input
                            type="file"
                            hidden
                            multiple
                            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            onChange={(e) => props.uploadFiles(e)}
                          />
                          {/* {props.translate('uploadImagesDoc')}{" "} */}
                          {/* <PublishIcon  style={{ color: '#fff', marginLeft:15}}/> */}
                          {/* </Button>
                          </Tooltip> */}

                          <div
                            style={{
                              display: "inline-flex",
                              flexWrap: "wrap",
                              marginTop: "15px",
                            }}
                          >
                            {props.accountFilesData &&
                            props.accountFilesData.length > 0
                              ? props.accountFilesData.map((data, key) => (
                                  <div
                                    style={{
                                      position: "relative",
                                      margin: "0 15px 20px 0",
                                    }}
                                    key={key}
                                  >
                                    <Tooltip
                                      placement="right-end"
                                      title={data.fileName}
                                    >
                                      <a
                                        style={{
                                          padding: "10px",
                                          background: "#fff",
                                          borderRadius: "5px",
                                          boxShadow:
                                            "0 0 10px rgba(0, 0, 0, 0.1)",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          width: "135px",
                                          display: "block",
                                          textAlign: "center",
                                        }}
                                        download={data.fileName}
                                        href={data.url}
                                        target={"_blank"}
                                      >
                                        {data.fileName}
                                      </a>
                                    </Tooltip>
                                    <CancelIcon
                                      style={{
                                        position: "absolute",
                                        top: "-10px",
                                        right: "-10px",
                                        cursor: "pointer",
                                        zIndex: "99",
                                        background: "#fff",
                                        borderRadius: "50%",
                                      }}
                                      onClick={() =>
                                        props.removeAccountFile(data.id)
                                      }
                                    />
                                  </div>
                                ))
                              : null}
                            {props.uploadDoc &&
                            props.uploadDoc.length > 0
                              ? props.uploadDoc.map((data, key) => (
                                  <div
                                    style={{
                                      position: "relative",
                                      margin: "0 15px 20px 0",
                                    }}
                                    key={key}
                                  >
                                    <Tooltip placement="right-end" title={data}>
                                      <a
                                        style={{
                                          padding: "10px",
                                          background: "#fff",
                                          borderRadius: "5px",
                                          boxShadow:
                                            "0 0 10px rgba(0, 0, 0, 0.1)",
                                          cursor: "pointer",
                                          textDecoration: "none",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          width: "135px",
                                          display: "block",
                                          textAlign: "center",
                                        }}
                                      >
                                        {data}
                                      </a>
                                    </Tooltip>
                                    <CancelIcon
                                      style={{
                                        position: "absolute",
                                        top: "-10px",
                                        right: "-10px",
                                        cursor: "pointer",
                                        zIndex: "99",
                                        background: "#fff",
                                        borderRadius: "50%",
                                      }}
                                      onClick={() =>
                                        props.removeFiles(key)
                                      }
                                    />
                                  </div>
                                ))
                              : null}
                          </div>
                        </Grid>
                      </Grid>{" "}
                    </>
                  </>
                )}
  </Fragment>
);

export default EditAccountDetailsSection;
